export default {
  methods: {
    genTProgress: function genTProgress() {
      var col = this.$createElement('th', {
        staticClass: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [this.genProgress()]);

      return this.$createElement('thead', {
        staticClass: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VDataTable/mixins/progress.js
// module id = In/s
// module chunks = 0